<template>
  <div class="input-diagnosis">
    <input-cart
      v-model="innerValue"
      :categories="diagnosisCategories"
      :cart-title="cartTitle"
      :add-label="addLabel"
      :add-inside-label="addLabel"
      :no-label="noLabel"
      :show-no-button="false"
    />
  </div>
</template>

<script>

import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import { compareArrays } from '@/utils/arrayUtil';
import InputComponent from '../InputComponent';
import InputCart from '../InputCart/InputCart';

export default {
  name: 'InputDiagnosis',
  components: { InputCart },
  extends: InputComponent,
  props: {
    modelValue: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  emits: ['update:modelValue', 'continue'],
  data() {
    return {
      innerValue: null,
    };
  },
  computed: {
    // TODO: Localize
    ...mapState(useSurveyStore, ['language', 'diagnosisCategories']),
    noWarningText() {
      return this.$t('diagnosis.popupWarningNo');
    },
    cartTitle() {
      return this.$t('diagnosis.title');
    },
    addLabel() {
      return this.$t('diagnosis.buttonAdd');
    },
    noLabel() {
      return this.$t('diagnosis.buttonNo');
    },
  },
  watch: {
    modelValue: {
      handler() {
        const newInnerValue = compareArrays(this.modelValue, this.innerValue, true);

        if (newInnerValue === true) {
          // It's already the same values
          return;
        }

        this.innerValue = newInnerValue;
      },
      deep: true,
    },
    innerValue: {
      handler() {
        const newValue = compareArrays(this.innerValue, this.modelValue, true);

        if (newValue === true) {
          // It's already the same values
          return;
        }

        this.$emit('update:modelValue', newValue);
      },
      deep: true,
    },
  },
  beforeMount() {
    if (!this.innerValue) {
      this.innerValue = this.modelValue || [];
    }
  },
  methods: {
    continueWithoutProducts() {
      this.$emit('continue');
    },
    getName(item) {
      return item.name;
    },
  },
};

</script>

<style lang="scss" scoped>
</style>
